<template>
  <v-app class="bckgrnds">
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-card class="form-container" style="border:1px solid">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 md3 sm3 style="padding-right: 5px">
            <v-text-field v-model="form.firstName" label="First name *" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md3 sm3 style="padding-right: 5px">
            <v-text-field v-model="form.lastName" label="Last name *" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md3 sm3 style="padding-right: 5px">
            <v-text-field v-model="form.email" label="Email id"></v-text-field>
          </v-flex>
          <v-flex xs12 md3 sm3>
            <v-text-field v-model="form.mobileNumber" label="Mobile number *" type="Number" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md4 sm4 style="padding-right: 5px">
              <v-autocomplete
                dense
                v-model="selectedNature"
                :items="nature"
                label="Select Nature *"
                item-text="nature"
                item-value="nature"
                :rules="emptyRule"
                required
               ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md3 sm3 style="padding-right: 5px">
              <v-autocomplete
                dense
                v-model="selectedSource"
                :items="source"
                label="Select Source *"
                item-text="source"
                item-value="source"
                :rules="emptyRule"
                required
               ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm3 md3>
            <v-autocomplete
                              dense
                              v-model="selectedLevel"
                              :items="level"
                              label="Select Level"
                              item-text="levelName"
                              item-value="id"
                              :rules="emptyRule"
                              required
                              ></v-autocomplete>
          </v-flex>
          <v-flex xs1 sm1 md1 style="padding-top:25px">
                <v-icon color="green" size="25px" @click.stop="dialog4 = true">add_circle</v-icon>
                <v-dialog
      v-model="dialog4"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Add Level
        </v-card-title>

        <v-card-text>
         <v-form ref="form4" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="form4.levelName"
                :rules="emptyRule"
                label="Level name"
                required
              ></v-text-field>
            </v-flex>
            
          </v-layout>
      </v-form>
        </v-card-text>
       
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-spacer></v-spacer>
       <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="submit4()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
                                  </v-flex>
          <v-flex xs12>
              <v-toolbar flat color="transparent">
                  <v-toolbar-title class="grey--text">Selection(s)</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>

              <v-dialog v-model="dialog" max-width="500px" persistent>
                  <v-btn color="primary" depressed slot="activator">Add new</v-btn>
                  <v-card style="border-radius: 10px">
                      <v-card-text>
                          <v-container grid-list-md>
                              <v-layout wrap>
                                  <v-flex xs11 sm11 md11>
                                       <v-autocomplete
                              dense
                              v-model="selectedCountry"
                              :items="country"
                              label="Select Country"
                              item-text="countryName"
                              item-value="id"
                              persistent-hint
                              return-object
                              single-line
                              ></v-autocomplete>
                                  </v-flex>

                                  <v-flex xs1 sm1 md1 style="padding-top:25px">
                <v-icon color="green" size="25px" @click.stop="dialog1 = true">add_circle</v-icon>
                <v-dialog
      v-model="dialog1"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Add Country
        </v-card-title>

        <v-card-text>
         <v-form ref="form1" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="form1.countryName"
                :rules="emptyRule"
                label="Country name"
                required
              ></v-text-field>
            </v-flex>
            
          </v-layout>
      </v-form>
        </v-card-text>
       
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-spacer></v-spacer>
       <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="submit1()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
                                  </v-flex>

                                  <v-flex xs11 sm11 md11>
                                       <v-autocomplete
                              dense
                              v-model="selectedUniversity"
                              :items="university"
                              label="Select University"
                              item-text="universityName"
                              item-value="id"
                              persistent-hint
                              return-object
                              single-line
                              ></v-autocomplete>
                                  </v-flex>

                                  <v-flex xs1 sm1 md1 style="padding-top:25px">
                <v-icon color="green" size="25px" @click.stop="dialog2 = true">add_circle</v-icon>
                <v-dialog
      v-model="dialog2"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Add University
        </v-card-title>

        <v-card-text>
         <v-form ref="form2" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="form2.universityName"
                :rules="emptyRule"
                label="University name"
                required
              ></v-text-field>
            </v-flex>
            
          </v-layout>
      </v-form>
        </v-card-text>
       
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-spacer></v-spacer>
       <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="submit2()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
                                  </v-flex>

                                  <v-flex xs11 sm11 md11>
                                       <v-autocomplete
                              dense
                              v-model="selectedCourse"
                              :items="course"
                              label="Select Course"
                              item-text="courseName"
                              item-value="id"
                              persistent-hint
                              return-object
                              single-line
                              ></v-autocomplete>
                                  </v-flex>

                                  <v-flex xs1 sm1 md1 style="padding-top:25px">
                <v-icon color="green" size="25px" @click.stop="dialog3 = true">add_circle</v-icon>
                <v-dialog
      v-model="dialog3"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Add Course
        </v-card-title>

        <v-card-text>
         <v-form ref="form3" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="form3.courseName"
                :rules="emptyRule"
                label="Course name"
                required
              ></v-text-field>
            </v-flex>
            
          </v-layout>
      </v-form>
        </v-card-text>
       
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-spacer></v-spacer>
       <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="submit3()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
                                  </v-flex>
                              </v-layout>
                          </v-container>
                      </v-card-text>
                      <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" flat @click="close()">Cancel</v-btn>
                    <v-btn color="success" flat @click="save()">Save</v-btn>
                  </v-card-actions>
                  </v-card>
              </v-dialog>
              </v-toolbar>

              <v-data-table
              :headers="headers"
              :items="itemAdded"
              :disable-initial-sort="true"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.index + 1 }}</td>
                <td class="text-xs-left">{{ props.item.countryName }}</td>
                <td class="text-xs-left">{{ props.item.universityName }}</td>
                <td class="text-xs-left">{{ props.item.courseName }}</td>
                <td class="justify-center">
                  <v-icon color="error" class="ml-3" small @click="deleteItem(props.item)">delete</v-icon>
                </td>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12></v-flex>

          <v-flex xs12 sm2 md2 style="margin-top:30px">
              <b-form-checkbox
               v-model="form.document"
            >
               Document
            </b-form-checkbox>
          </v-flex>

          <v-flex xs12 sm10 md10 v-if="form.document==true">
               <v-textarea :auto-grow="true" v-model="form.documentType" rows="1" row-height="15" label="Details of Documents"></v-textarea>
          </v-flex>

          <v-flex xs12 style="padding-top:10px">
               <v-textarea outline :auto-grow="true" v-model="form.notes" rows="5" row-height="15" label="Notes"></v-textarea>
          </v-flex>
          

          <v-flex xs12 style="text-align:right">
            <v-btn v-if="itemAdded.length > 0" depressed :loading="btnSave" color="primary" dark @click="onSubmit()">Save </v-btn>
            <v-btn depressed color="orange" dark @click="back()">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      dialog: false,
      dateModel: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,

      itemAdded: [],


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },

      headers: [
        { text: "#", value: "#" },
        { text: "Country", value: "countryName" },
        { text: "Universty", value: "universityName" },
        { text: "Course", value: "courseName" },
        { text: "Remove", value: "remove" }
      ],

      valid: true,
      roleType: sessionStorage.roles,

      nature: ["Training", "Application process", "Training & Application process"],
      selectedNature: null,

      source: ["Facebook", "Justdial", "Sulekha", "Google", "Instagram", "Website", "Reference std", "Reference bp", "Reference emp", "Data calling", "Filed campaign", "Campus activities", "Leaflets" ],
      selectedSource: null,

      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Leads",
          disabled: false,
          to: "/lead"
        },
        {
          text: "Create Lead",
          disabled: true,
          to: "/createLead"
        }
      ],

      country: null,
      selectedCountry: null,

      university: null,
      selectedUniversity: null,

      course: null,
      selectedCourse: null,

      level: null,
      selectedLevel: null,

      form: {
        firstName: null,
        lastName: null,
        mobileNumber: null,
        email: null,
        document: false,
        documentType: null,
        notes: null
      },

      form1: {
        countryName: null
      },
      form2: {
        universityName: null
      },
      form3: {
        courseName: null
      },
      form4: {
        levelName: null
      },
    };
  },

  mounted() {
      this.getData1();
      this.getData2();
      this.getData3();
      this.getData4();
    },

  methods: {
    getData1() {
      this.axios
        .get(config.API + "Countries", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.country = res.data;
          this.getData1();
        });
    },
    
    getData2() {
      this.axios
        .get(config.API + "Universities", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.university = res.data;
          this.getData2();
        });
    },
        
    getData3() {
      this.axios
        .get(config.API + "Courses", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.course = res.data;
          this.getData3();
        });
    },

    getData4() {
      this.axios
        .get(config.API + "Levels", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.level = res.data;
          this.getData4();
        });
    },
        
    submit1() {
    if (this.$refs.form1.validate()) {
      this.axios
          .post(
            config.API + "Countries",
            {
              countryName: this.form1.countryName
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log("Success");
            this.$toaster.success("Country successfully added");
            this.form1.countryName = null;
            this.dialog1 = false;
          })
          .catch(err => {
            console.log(err.message);
          });
    }
    },

    submit2() {
    if (this.$refs.form2.validate()) {
      this.axios
          .post(
            config.API + "Universities",
            {
              universityName: this.form2.universityName
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log("Success");
            this.$toaster.success("University successfully added");
            this.form2.universityName = null;
            this.dialog2 = false;
          })
          .catch(err => {
            console.log(err.message);
          });
    }
    },

    submit3() {
    if (this.$refs.form3.validate()) {
      this.axios
          .post(
            config.API + "Courses",
            {
              courseName: this.form3.courseName
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log("Success");
            this.$toaster.success("Course successfully added");
            this.form3.courseName = null;
            this.dialog3 = false;
          })
          .catch(err => {
            console.log(err.message);
          });
    }
    },

    submit4() {
    if (this.$refs.form4.validate()) {
      this.axios
          .post(
            config.API + "Levels",
            {
              levelName: this.form4.levelName
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log("Success");
            this.$toaster.success("Level successfully added");
            this.form4.levelName = null;
            this.dialog4 = false;
          })
          .catch(err => {
            console.log(err.message);
          });
    }
    },

    back() {
      this.$router.go(-1);
    },

    close() {
      this.dialog = false;
      this.selectedCountry = null;
      this.selectedUniversity = null;
      this.selectedCourse = null;
    },
    deleteItem(item) {
      if(confirm("Are you sure you want to delete this selection?")) {
         const index = this.itemAdded.indexOf(item);
         this.itemAdded.splice(index, 1);
      }
    },

    save() {
        if(this.selectedCountry != null && this.selectedUniversity != null && this.selectedCourse != null) {
            let lth = this.itemAdded.length;
            if (lth == 0) {
              this.itemAdded.push({
               countryId: JSON.parse(this.selectedCountry.id),
               universityId: JSON.parse(this.selectedUniversity.id),
               courseId: JSON.parse(this.selectedCourse.id),
               countryName: this.selectedCountry.countryName,
               universityName: this.selectedUniversity.universityName,
               courseName: this.selectedCourse.courseName
              });

              this.close();
            }
            else {
                let flag = false;

                for(let i = 0; i < lth; i++) {
                    let _countryId = this.itemAdded[i].countryId;
                    let _universityId = this.itemAdded[i].universityId;
                    let _courseId = this.itemAdded[i].courseId;

                    if(_countryId == this.selectedCountry.id && _universityId == this.selectedUniversity.id && _courseId == this.selectedCourse.id) {
                        flag = true;
                    }
                }

                if (flag == true) {
                this.$toaster.error(`Already Taken!!`);
               }
               else {
                   this.itemAdded.push({
               countryId: JSON.parse(this.selectedCountry.id),
               universityId: JSON.parse(this.selectedUniversity.id),
               courseId: JSON.parse(this.selectedCourse.id),
               countryName: this.selectedCountry.countryName,
               universityName: this.selectedUniversity.universityName,
               courseName: this.selectedCourse.courseName
              });

              this.close();
               }
            }
        }
        else {
            this.$toaster.error(`Please select one!!`);
        }
        
      },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `Leads`,
            {
              firstName: this.form.firstName,
              lastName: this.form.lastName,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              email: this.form.email,
              nature: this.selectedNature,
              source: this.selectedSource,
              document: this.form.document,
              documentType: this.form.documentType,
              notes: this.form.notes,
              levelId: JSON.parse(this.selectedLevel),

              leadDetails: this.itemAdded
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Lead successfully added");
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(`Mobile no is already exist`);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
.bckgrnds {
  background-image: linear-gradient(-180deg, #eeeeee, #bdbdbd) !important;
  background-size:cover !important;
}
</style>
